import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { HomePage } from '@/pages/HomePage';
import { TokensPage } from '@/pages/TokensPage';
import { PoolsPage } from '@/pages/PoolsPage';
import { SwapPage } from '@/pages/SwapPage';
import { RoutingPage } from '@/pages/RoutingPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/chain-138" element={<Navigate to="/" replace />} />
          <Route path="/tokens" element={<TokensPage />} />
          <Route path="/pools" element={<PoolsPage />} />
          <Route path="/swap" element={<SwapPage />} />
          <Route path="/routing" element={<RoutingPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
